import moment from 'moment';
import last from 'lodash/last';
import includes from 'lodash/includes';
import {keyMirror} from 'utils/DBUtils';

export const prizeImagesPageName = 'prizeImages';

export const PrizeItemTypes = keyMirror({
  COINS: null,
  POINTS: null,
  OTHER: null,
  GIFT_CARD: null,
  VIRTUAL_GIFT_CARD: null
});

export const isSponsored = prize => prize.type === 'CHALLENGE';

export const hasMonetaryValue = prize => !includes([
  PrizeItemTypes.POINTS,
  PrizeItemTypes.COINS
], prize.itemType);

export const requiresW9AndAffidavit = prize => prize.value >= 600;

// for initializing a new drawDate item to be 1 day after: either that of the last
// drawDate or the prize's start date.
export const getInitialDrawDate = prize => {
  const lastDrawInfoItem = last(prize.drawInfo);
  const lastDrawDate = moment(lastDrawInfoItem ? lastDrawInfoItem.drawDate : prize.startTime);
  return lastDrawDate.add(1, 'week').valueOf();
};



// WEBPACK FOOTER //
// ./public/pages/EditPrize/utils.js